import { useRecordContext } from 'ra-core';
import ReactQuill from "react-quill";

import 'react-quill/dist/quill.snow.css';
import './index.scss';

const ReadOnlyEditor = (props) => {
  const { source } = props;
  const record = useRecordContext(props);

  return (
    <div className="quill-readonly-container">
      <ReactQuill
        value={record[source] || ''}
        readOnly={true}
        theme={null}
        modules={{ toolbar: false }}
        style={{
          border: 'none',
          padding: 0
        }}
      />
    </div>
  );
}

export default ReadOnlyEditor;